<template>
  <hel-module title="单一来源依赖风险" v-loading="loading" style="overflow: hidden;">
    <div class="risk-list">
      <div class="risk-row risk-row-head">
        <span class="cell cell-name">供应商名称</span>
        <span class="cell cell-cat">主营品类</span>
        <span class="cell cell-share">3年份额(%)</span>
        <span class="cell cell-risk">风险等级</span>
      </div>
      <div class="risk-list-body">
        <div
          v-for="(item, idx) in riskList"
          :key="idx"
          class="risk-row"
        >
          <span class="cell cell-name" :title="item.supplierName">{{ item.supplierName }}</span>
          <span class="cell cell-cat" :title="item.categoryName">{{ item.categoryName }}</span>
          <span class="cell cell-share">{{ item.shareRatio }}%</span>
          <span
            class="cell cell-risk"
            :style="{ color: riskColor(item.riskLevel) }"
          >{{ riskText(item.riskLevel) }}</span>
        </div>
        <div v-if="!riskList.length" class="risk-empty">暂无数据</div>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from '../common/module/index.vue'
import { getSingleSourceRisk } from '@/api/procurement'

export default {
  name: 'SingleSourceRisk',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      riskList: []
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    riskText(level) {
      const map = {
        HIGH: '高风险',
        MEDIUM: '中风险',
        LOW: '低风险'
      }
      return map[level] || level || ''
    },
    riskColor(level) {
      if (level === 'HIGH') return '#F32424'
      if (level === 'MEDIUM') return '#F4B13D'
      return '#52C41A'
    },
    async fetchData() {
      this.loading = true
      try {
        const res = await getSingleSourceRisk()
        if (res && res.code === 200) {
          this.riskList = Array.isArray(res.data) ? res.data : []
        } else {
          this.riskList = []
        }
      } catch (error) {
        console.error('获取单一来源依赖风险数据失败:', error)
        this.riskList = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  font-size: 12px;
  color: #1e2226;
  border: 1px solid #e5e7eb;
  border-radius: 2px;
}
.risk-row {
  display: flex;
  align-items: center;
  padding: 6px 4px;
  border-bottom: 1px solid #eef0f3;
  line-height: 18px;
}
.risk-row-head {
  font-weight: 600;
  color: #6b7280;
  border-bottom-color: #e5e7eb;
}
.risk-list-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.cell {
  padding: 0 4px;
  box-sizing: border-box;
}
.cell-name {
  flex: 2;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cell-cat {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cell-share {
  width: 72px;
  text-align: right;
}
.cell-risk {
  width: 80px;
  text-align: center;
}
.risk-empty {
  text-align: center;
  color: #9ca3af;
  padding: 16px 0;
}
</style>
